module.exports = __webpack_public_path__ + "static/img/yqtTopNew.4317c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yqtTopNew.png
// module id = GF/E
// module chunks = 0